import { render, staticRenderFns } from "./memberBaseInfo.vue?vue&type=template&id=580c9287&scoped=true"
import script from "./memberBaseInfo.vue?vue&type=script&lang=js"
export * from "./memberBaseInfo.vue?vue&type=script&lang=js"
import style0 from "./memberBaseInfo.vue?vue&type=style&index=0&id=580c9287&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580c9287",
  null
  
)

export default component.exports